import { Table } from "@mantine/core"

export function SimpleTable<T>({
  data,
  header,
  renderRow,
  containerProps,
  stickyHeader,
}: {
  header?: string[]
  data: T[]
  renderRow: (row: T) => React.ReactNode[]
  containerProps?: (row: T, colIndex: number) => any
  stickyHeader?: boolean
}) {
  return (
    <Table stickyHeader={stickyHeader} mt="xs">
      {header ? (
        <Table.Thead>
          <Table.Tr>
            {header.map((v) => (
              <Table.Th key={v}>{v}</Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
      ) : null}
      <Table.Tbody>
        {data.map((element, i) => (
          <Table.Tr key={i}>
            {renderRow(element).map((v, i) => (
              <Table.Td
                key={i}
                {...(containerProps ? containerProps(element, i) : {})}
                // style={{
                //   display: "flex",
                //   justifyContent: "flex-end"
                // }}
              >
                {v}
              </Table.Td>
            ))}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  )
}
